import React from 'react';
import {can} from '../../../_common/components/Permissions';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

export function ActionsColumnFormatter(transferID, agentID, {history}) {
  const goToTransfersByAgent = () => {
    if (agentID) {
      history.push(`/transfersByAgent/${agentID}`);
    }
  };
  const goToTransfer = () => {
    if (agentID && transferID) {
      history.push(`/transfersByAgent/${agentID}`, transferID);
    }
  };

  return can('view', 'transfersPage') && (
    <div className={'d-flex justify-content-center'}>
      {can('full', 'transfersPage') && (
        <a
          title="העברות של הסוכן"
          className={`btn btn-icon btn-light btn-sm mx-2 custom-action-button 
          ${agentID ? '' : 'custom-disabled-button cursor-default opacity-60'}
          `}
          onClick={goToTransfersByAgent}
        >
          <img
            src={toAbsoluteUrl('/media/svg/User-brandColor.svg')}
            alt="link"
          />
        </a>
      )}
      {can('full', 'transfersPage') && (
        <a
          title="העברה"
          className={`btn btn-icon btn-light btn-sm mx-2 custom-action-button 
          ${agentID ? '' : 'custom-disabled-button cursor-default opacity-60'}
          `}
          onClick={goToTransfer}
        >
          <img
            src={toAbsoluteUrl('/media/svg/Show_brandColor.svg')}
            alt="view"
            height={24}
          />
        </a>
      )}
    </div>
  );
}
